var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('router-view',{key:_vm.$router.currentRoute.meta.name})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }